export const TemplateCategoryEnum = {
    All: 'All',
    DIY: 'DIY',
    Renovation: 'Renovation',
    Structures: 'Structures',
    HousePlans: 'House Plans',
} as const;

export type TemplateCategoryType =
    (typeof TemplateCategoryEnum)[keyof typeof TemplateCategoryEnum];
